import { Feature } from "features/interfaces";
import page from "./_ProjectReportPage/_ProjectReportPage";
import { actions, reducer } from "./ducks";
import saga from "./saga";


export const projectReportFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
